/**
 * Configuration centralisée des capsules vidéo explicatives.
 *
 * ➡️ Pour ajouter/mettre à jour une vidéo : renseignez simplement `youtubeId`.
 *    L'ID YouTube est la partie après `v=` dans l'URL (ex: pour
 *    https://www.youtube.com/watch?v=dQw4w9WgXcQ → youtubeId = 'dQw4w9WgXcQ').
 *    Laissez à `null` pour afficher le badge "Bientôt disponible".
 *
 * Vous pouvez aussi utiliser Vimeo avec `vimeoId: '123456789'`.
 */
export const MODULE_VIDEOS = [
  // ===== Pack Standard =====
  {
    key: 'quotes',
    category: 'Pack Standard',
    title: 'Créer un devis en 2 minutes',
    description: 'Ajouter articles, TVA, remise, dictée vocale et envoi par email.',
    duration: '2 min',
    youtubeId: null,
  },
  {
    key: 'invoices',
    category: 'Pack Standard',
    title: 'Facturer et relancer automatiquement',
    description: 'Convertir un devis en facture, envoyer et automatiser les relances.',
    duration: '2 min',
    youtubeId: null,
  },
  {
    key: 'crm',
    category: 'Pack Standard',
    title: 'Gérer vos clients et le pipeline',
    description: 'Fiches contacts, timeline d\'activités, secteurs et sources.',
    duration: '3 min',
    youtubeId: null,
  },
  {
    key: 'agenda',
    category: 'Pack Standard',
    title: 'Agenda et rendez-vous',
    description: 'Bloquer des créneaux, envoyer invitations, synchro Google Calendar.',
    duration: '2 min',
    youtubeId: null,
  },
  {
    key: 'library',
    category: 'Pack Standard',
    title: 'Bibliothèque de prix réutilisable',
    description: 'Créer un catalogue d\'articles avec prix, catégories et import Excel.',
    duration: '2 min',
    youtubeId: null,
  },
  {
    key: 'accounting',
    category: 'Pack Standard',
    title: 'Export comptable (FEC, Sage, Winbooks…)',
    description: 'Générer les journaux et exports pour votre comptable.',
    duration: '2 min',
    youtubeId: null,
  },
  {
    key: 'cashflow',
    category: 'Pack Standard',
    title: 'Trésorerie prévisionnelle',
    description: 'Visualiser vos encaissements/décaissements à 3 mois.',
    duration: '2 min',
    youtubeId: null,
  },

  // ===== Modules optionnels =====
  {
    key: 'tasks',
    category: 'Modules',
    title: 'Tâches & Planning équipe',
    description: 'Assigner, chronométrer, ajouter photos avant/après et check-lists.',
    duration: '3 min',
    youtubeId: null,
  },
  {
    key: 'stock',
    category: 'Modules',
    title: 'Gestion des stocks',
    description: 'Produits, entrées/sorties, alertes seuil bas, auto-déduction devis.',
    duration: '2 min',
    youtubeId: null,
  },
  {
    key: 'hr',
    category: 'Modules',
    title: 'Module RH',
    description: 'Employés, contrats, congés payés BE/FR.',
    duration: '2 min',
    youtubeId: null,
  },
  {
    key: 'meetings',
    category: 'Modules',
    title: 'Réunions IA',
    description: 'Dictez ou collez vos notes — l\'IA extrait résumé et actions.',
    duration: '2 min',
    youtubeId: null,
  },
  {
    key: 'ai_voice',
    category: 'Modules',
    title: 'Dictée vocale IA',
    description: 'Dictez un devis ou une tâche, l\'IA structure automatiquement.',
    duration: '2 min',
    youtubeId: null,
  },
  {
    key: 'team',
    category: 'Modules',
    title: 'Multi-utilisateurs',
    description: 'Inviter votre équipe et gérer les permissions par rôle.',
    duration: '2 min',
    youtubeId: null,
  },
  {
    key: 'analytics',
    category: 'Modules',
    title: 'Analytics & journal',
    description: 'Statistiques d\'usage, journal emails et conversion devis→factures.',
    duration: '2 min',
    youtubeId: null,
  },
  {
    key: 'campaigns',
    category: 'Modules',
    title: 'Campagnes automatisées',
    description: 'Séquences email + tâches d\'appel avec relances IA.',
    duration: '3 min',
    youtubeId: null,
  },
  {
    key: 'trips',
    category: 'Modules',
    title: 'Audit trajets',
    description: 'Trajets chronométrés avec météo, trafic et snapshot Google Maps.',
    duration: '2 min',
    youtubeId: null,
  },
];
